class ReviveHeader extends HTMLElement {
  connectedCallback() {
    this.burger = this.querySelector('[data-menu-open]');
    this.menu = this.querySelector('[data-mobile-menu]');
    this.closers = this.querySelectorAll('[data-menu-close]');
    this.lastFocused = null;

    if (this.burger && this.menu) {
      this.burger.addEventListener('click', () => this.openMenu());
      this.closers.forEach((el) => el.addEventListener('click', () => this.closeMenu()));
      this.menu.querySelector('.revive-mobile-menu__panel').addEventListener('keydown', (e) => this.trapFocus(e));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.menu.hidden) this.closeMenu();
      });
    }

    // The cart button ([data-cart-open]) is handled by revive-cart.js.
    document.addEventListener('cart:update', (e) => this.updateCount(e));
    document.addEventListener('cart:refresh', (e) => this.updateCount(e));

    if (this.dataset.sticky === 'true') {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.classList.toggle('is-scrolled', window.scrollY > 40);
      this.ticking = false;
    });
  }

  openMenu() {
    this.lastFocused = document.activeElement;
    this.menu.hidden = false;
    this.burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const closeBtn = this.menu.querySelector('.revive-mobile-menu__close');
    if (closeBtn) closeBtn.focus();
  }

  closeMenu() {
    this.menu.hidden = true;
    this.burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (this.lastFocused) this.lastFocused.focus();
  }

  trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusables = Array.from(this.menu.querySelectorAll('a, button, summary')).filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  updateCount(e) {
    const countEl = this.querySelector('[data-cart-count]');
    if (!countEl) return;
    const count = e?.detail?.cartData?.item_count ?? e?.detail?.itemCount;
    if (typeof count === 'number') {
      countEl.textContent = count;
      countEl.hidden = count === 0;
    }
  }
}

if (!customElements.get('revive-header')) customElements.define('revive-header', ReviveHeader);